module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "promos"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddPromo
    }
  }, [_c('a', {
    staticClass: "button is-info rounded"
  }, [_vm._v("Добавить акцию")])])]), _vm._v(" "), _c('div', {
    staticClass: "promos"
  }, _vm._l((_vm.currentpromos), function(promo) {
    return _c('promo', {
      key: promo.id,
      attrs: {
        "promo": promo
      }
    })
  }), 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "promos"
  }, _vm._l((_vm.completedpromos), function(promo) {
    return _c('promo', {
      key: promo.id,
      attrs: {
        "promo": promo
      }
    })
  }), 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Завершившиеся акции")]), _vm._v(" "), _c('span', [_vm._v("По умолчанию завершившиеся акции не отображаются на сайте")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-414e37e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Promos/Index.vue
// module id = 936
// module chunks = 0